import store from '@/store';
import { DEFAULT_SPEED_LIMIT_COLORS, VEHICLE_SPEED_LIMIT } from '../constants';

export const getColorBySpeed = (vehicle) => {
    const limits = store.state.speedLimit;
    const speed = +vehicle.speed;

    if (!limits.length || speed == undefined) {
        return DEFAULT_SPEED_LIMIT_COLORS.SAFE_SPEED;
    }

    const speedLimit = limits.find(l => l.vehicleTypeId == vehicle.vehicleType);
    if (!speedLimit || speed <= speedLimit.safeSpeed) {
        let safeSpeed = store.state.vehicleSpeedLimitColors.find(c => c.key == VEHICLE_SPEED_LIMIT.SAFE_SPEED);
        return safeSpeed ? safeSpeed.value : DEFAULT_SPEED_LIMIT_COLORS.SAFE_SPEED;
    }
    else if (speed > speedLimit.safeSpeed && speed < speedLimit.highSpeed) {
        let moderateSpeed = store.state.vehicleSpeedLimitColors.find(c => c.key == VEHICLE_SPEED_LIMIT.MODERATE_SPEED);
        return moderateSpeed ? moderateSpeed.value : DEFAULT_SPEED_LIMIT_COLORS.MODERATE_SPEED;
    } else {
        let highSpeed = store.state.vehicleSpeedLimitColors.find(c => c.key == VEHICLE_SPEED_LIMIT.HIGH_SPEED);
        return highSpeed ? highSpeed.value : DEFAULT_SPEED_LIMIT_COLORS.HIGH_SPEED;
    }
}